function fillFieldForm(arrayCamposTipo, $ocultData, $targetModal) {
    $.each(arrayCamposTipo, (tipo, arrayCampos) => {
        if (tipo === 'checkbox') {
            $.each(arrayCampos.data, (index, campo) => {
                let tempValue = $ocultData.find(
                    `input[name="${campo}"]`).val();
                let targetElem = $targetModal
                    .find(`input[type="${tipo}"][name="${campo}"]`);
                targetElem.prop('checked', tempValue == 1);

                if ('currentData' in (arrayCampos.attr || {})) {
                    targetElem.attr(arrayCampos.attr.currentData, tempValue);
                }
                else {
                    targetElem.attr(arrayCampos.attr || {});
                }
            });
            return;
        }
        $.each(arrayCampos.data, (index, campo) => {
            let typeFill = arrayCampos.typeFill || 'val';
            let tempValue = $ocultData.find(
                `input[name="${campo}"]`).val();

            let targetElem = $targetModal
                .find(`${tipo}[name="${campo}"]`);

            targetElem[typeFill](tempValue)
            if ('currentData' in (arrayCampos.attr || {})) {
                targetElem.attr(arrayCampos.attr.currentData, tempValue);
            }
            else {
                targetElem.attr(arrayCampos.attr || {});
            }
            return;
        });
    });
}
module.exports = fillFieldForm;
